import { render } from "./AreaChart.vue?vue&type=template&id=624c2769"
import script from "./AreaChart.vue?vue&type=script&lang=js"
export * from "./AreaChart.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__